import { buildHandOffUrl } from './sso-hand-off'

// Copy and links for the sign-in page. Pure, so the flag-off wording (today's) and the flag-on wording
// ("Navo24 account") are both pinned by tests. See docs/shared-sign-in.md.

export interface SignInCopy {
  intro: string
  /** shown after the magic link was requested */
  sentNote: string | null
  /** label of the link to the hub's own sign-in (password, sign-up, reset), or null when not offered */
  hubLabel: string | null
}

export function signInCopy(sharedSignIn: boolean): SignInCopy {
  if (!sharedSignIn) {
    return {
      intro: 'One navo24 login across all four products. Continue with a provider or a magic link.',
      sentNote: null,
      hubLabel: null,
    }
  }
  return {
    intro:
      'Your Navo24 account: one login across TrackingMCP, AirCargo, Schedules, Loading and Freight rates. New here? Continue with a provider or a magic link and your account is created.',
    sentNote:
      'The link opens your Navo24 workspace. From there open Freight rates and you are signed in here too.',
    hubLabel: 'Use a password, or reset one, on Navo24',
  }
}

/**
 * Where the hub's own sign-in sends a visitor back to this page signed in (via the #sso= hand-off), or null
 * off the production family host. Carries only this page's URL, never a token.
 */
export function hubSignInUrl(href: string): string | null {
  return buildHandOffUrl(href)
}

/** The friendly text for the project's refusal to create an account (a blocked or duplicate mailbox). */
export function signUpErrorMessage(message: string): string {
  return /database error saving new user/i.test(message)
    ? 'An account for this email may already exist, or the address is not accepted. Try signing in, or use another email.'
    : message
}
